module.exports = __webpack_public_path__ + "static/media/default.6d737788.svg";